import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import SyncStatusIndicator from './SyncStatusIndicator';
import { AuthNavButtons } from './AuthNavButtons';
import { LanguageSelector } from './LanguageSelector';
import { ThemeToggleButton } from './ThemeToggleButton';
import { Bars3Icon } from '@heroicons/react/24/outline';
import { NavigationItems } from './NavigationItems';
import { MobileMenu } from './MobileMenu';
import { CreateBudgetActions } from './CreateBudgetActions';

export const Navigation: React.FC = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <>
      <nav className="sticky top-0 z-30 border-b border-slate-200 bg-white/80 backdrop-blur dark:border-surface-700 dark:bg-surface-900/80">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="flex h-14 items-center justify-between">
            <div className="flex items-center">
              <Link
                to="/landing"
                className="flex items-center gap-2 text-lg font-bold text-slate-800 dark:text-white"
              >
                <img src="/logo.svg" alt="FairBalance" className="h-7 w-7" />
                <span className="hidden sm:inline">FairBalance</span>
              </Link>
              <div className="ml-4 hidden md:flex lg:ml-6">
                <NavigationItems showLabels={true} className="space-x-1 lg:space-x-2" />
              </div>
            </div>
            <div className="flex items-center gap-1.5 sm:gap-2">
              <CreateBudgetActions showText={false} spacing="gap-1.5" />
              <div className="hidden md:flex md:items-center md:gap-1 lg:gap-2">
                <AuthNavButtons />
                <div className="hidden xl:block">
                  <SyncStatusIndicator />
                </div>
                <ThemeToggleButton />
                <LanguageSelector />
              </div>
              <button
                onClick={() => setIsMobileMenuOpen(true)}
                className="rounded-md p-1.5 text-slate-400 hover:bg-slate-100 hover:text-slate-500 dark:hover:bg-surface-800 md:hidden"
              >
                <Bars3Icon className="h-5 w-5" />
              </button>
            </div>
          </div>
        </div>
      </nav>
      <MobileMenu isOpen={isMobileMenuOpen} onClose={() => setIsMobileMenuOpen(false)} />
    </>
  );
};
